/**
 * This is yuri-timeline script.js file
 */
import YuriTimelineComment from '@/components/yuri-timeline/yuri-timeline-comment/index.vue';

export default {
    name: 'yuri-timeline',
    props: {
        issueUuid: null,
        timeline: {
            type: Array,
            required: true,
            default: []
        }
    },
    components: {
        YuriTimelineComment
    },
    methods: {
        // /**
        //  * Gets User Initials
        //  * @param {Object} user Detalles del usuario
        //  * @return {String} User initials
        //  */
        // getUserInitials(user) {
        //     const abbr = `${user.given_name.substring(0, 1)}${user.family_name.substring(0, 1)}`;
        //     return abbr;
        // },
        /**
         * Descargar documento
         * @param {Object} documentFile Documento
         */
        download(documentFile) {
            // this.$issuesService.getDocument(this.$route.params.uuid, documentFile.uuid)
            this.$issuesService.getDocument(this.issue.uuid, documentFile.uuid).then(res => {
                const urlCreator = window.URL || window.webkitURL;
                this.filePreview = urlCreator.createObjectURL(res);
                this.fileType = res.type;
                this.fileName = documentFile.title;

                const fileLink = document.createElement('a');
                fileLink.href = this.filePreview;
                fileLink.setAttribute('download', this.fileName);
                document.body.appendChild(fileLink);
                fileLink.click();
            });
        }
    },
    computed: {
        /**
         * @override
         */
        getTimeCreated() {
            return new Date();
        },
        /**
         * @override
         */
        divideByDays() {
            const result = this.timeline.reduce((prev, current) => {
                // TODO haces mas entendible
                let exists = prev.find(x => x.date === this.$moment(current.created_on).format('MM-DD-YYYY'));
                // Si no existe lo creo con un array vacío en VALOR
                if (!exists) {
                    exists = { date: this.$moment(current.created_on).format('MM-DD-YYYY'), timeline: [] };
                    prev.push(exists);
                }
                // Se ordena la fecha de forma decreciente para que los últimos
                // comentarios aparezcan en la parte superior
                prev.sort((a, b) => {
                    return a.date >= b.date ? -1 : 1;
                });
                // Si el elemento actual tiene VALOR lo añado al array del
                // elemento existente
                if (current.created_on !== null) {
                    // Convierto el valor a numérico reemplazando el carácter separador
                    // Si es un valor numérico válido lo añado al resultado
                    exists.timeline.push(current);
                }
                // sort array
                exists.timeline = exists.timeline.sort((a, b) => {
                    return a.created_on >= b.created_on ? -1 : 1;
                });
                // Devuelvo el array resultado para la nueva iteración
                return prev;
            }, []);
            return result;
        }
    }
};
